export const handleChangeDataSuggestionsPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SUGGESTIONS', name, value
});